import {
  WhiteInstantSearchBuilder,
  MenuSelect,
  NoResults,
  Pagination,
  SortBy,
} from '@white-nl/instantsearch-components';

import { Hit } from '../components/references/results/Hit';
import Loading from '../components/references/results/Loading';
import Stats from '../components/ui/metadata/Stats';
import { ClearIndicator, DropdownIndicator } from '../components/ui/React-select';

const settings = document.getElementById('references-filters')?.dataset || null;
const whiteInstantSearchReferences = new WhiteInstantSearchBuilder();
if (settings) {
  const graphqlUrl = `${settings.nodeUrl}api/categories/applications`;
  fetch(graphqlUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ siteId: settings.siteId }),
  }).then((res) => res.json())
    .then((categories) => {
      const categoryLabelMapping: any = {};
      categories.entries.forEach(
        (category: {
          __typename: string;
          slug: string;
          title: string;
        }) => {
          categoryLabelMapping[category.slug] = category.title;
        },
      );

      whiteInstantSearchReferences
        .withSearchkit(
          settings.indexName || '',
          settings.publicUrl || '',
          settings.jwt || '',
          settings.refreshUrl || '',
        )
        .withWhiteInstantSearchRouting({
          baseUrl: settings.baseUrl,
          addTrailingSlashesToUrls: settings.trailingSlashes === '1',
        })
        .setHitsPerPage(21)
        .addAdditionalData({ hitsPerPage: 21 })
        .addHitComponent([
          {
            settings: {
              loading: {
                translations: {
                  loading: Craft.t('references', 'Loading references...'),
                },
              },
              noResults: {
                translations: {
                  noResults: Craft.t('references', 'Sorry, we can\'t find any references!'),
                  refinements: Craft.t('references', 'Try to reset your applied filters.'),
                  query: Craft.t('references', 'Please try another query.'),
                },
              },
            },
            component: Hit,
            loadingComponent: Loading,
            noResultsComponent: NoResults,
          },
        ])
        .addStatsComponent([
          {
            settings: {
              translations: {
                resultsFound: Craft.t('references', 'results found'),
                resultFound: Craft.t('references', 'result found'),
              },
            },
            component: Stats,
          },
        ])
        .addSortByComponent([
          {
            settings: {
              items: [
                {
                  label: Craft.t('references', 'Newest first'),
                  value: settings.indexName || '',
                },
                {
                  label: Craft.t('references', 'Alphabet A-Z'),
                  value: `${settings.indexName || ''}_title_asc`,
                },
                {
                  label: Craft.t('references', 'Alphabet Z-A'),
                  value: `${settings.indexName || ''}_title_desc`,
                },
              ],
              classNames: {
                control: () => 'form-select lg',
                menu: () => 'form-select-list',
              },
              unstyled: true,
              components: {
                DropdownIndicator,
              },
            },
            component: SortBy,
          },
        ])
        .addMenu([
          {
            settings: {
              attribute: 'applications',
              transformItems: (items) => items.map((item) => ({
                ...item,
                label: categoryLabelMapping[item.value],
              })),
              translations: {
                defaultOptionText: Craft.t('references', 'All applications'),
              },
              classNames: {
                control: () => 'form-select lg filter',
                menu: () => 'form-select-list',
              },
              className: 'col-12 col-md-4',
              isSearchable: false,
              isClearable: true,
              unstyled: true,
              limit: 50,
              components: {
                ClearIndicator,
                DropdownIndicator,
              },
            },
            component: MenuSelect,
          },
        ])
        .addMenu([
          {
            settings: {
              attribute: 'products',
              translations: {
                defaultOptionText: Craft.t('references', 'All products'),
              },
              className: 'col-12 col-md-4',
              classNames: {
                control: () => 'form-select lg filter',
                menu: () => 'form-select-list',
              },
              isSearchable: false,
              isClearable: true,
              unstyled: true,
              limit: 50,
              components: {
                ClearIndicator,
                DropdownIndicator,
              },
            },
            component: MenuSelect,
          },
        ])
        .addMenu([
          {
            settings: {
              attribute: 'countries',
              translations: {
                defaultOptionText: Craft.t('references', 'All countries'),
                noOptionsMessage: Craft.t('references', 'No country found'),
              },
              sortBy: (a, b) => {
                const nameA = a.name.toLocaleLowerCase();
                const nameB = b.name.toLocaleLowerCase();
                return nameA.localeCompare(nameB, document.documentElement.lang);
              },
              className: 'col-12 col-md-4',
              classNames: {
                control: () => 'form-select lg filter',
                menu: () => 'form-select-list',
              },
              isSearchable: false,
              isClearable: true,
              unstyled: true,
              limit: 50,
              components: {
                ClearIndicator,
                DropdownIndicator,
              },
            },
            component: MenuSelect,
          },
        ])
        .addPaginationComponent([
          {
            settings: {
              showFirst: false,
              showLast: false,
              classNames: {
                list: 'pagination',
                item: 'page-item',
                previousPageItem: 'previous',
                selectedItem: 'active',
                disabledItem: 'disabled',
                nextPageItem: 'next',
                link: 'page-link',
              },
              translations: {
                previousPageItemText: Craft.t('pagination', 'Previous'),
                previousPageItemAriaLabel: Craft.t('pagination', 'Go to previous page'),
                nextPageItemText: Craft.t('pagination', 'Next'),
                nextPageItemAriaLabel: Craft.t('pagination', 'Go to next page'),
              },
            },
            component: Pagination,
          },
        ])
        .setScrolling({
          includeAttributes: ['page'],
          element: '#filter-panel',
        })
        .where(`siteId:${settings.siteId}`)
        .build()
        .show();
    });
}
